import { render, staticRenderFns } from "./PaginationSkeleton.vue?vue&type=template&id=4262f0a6&"
import script from "./PaginationSkeleton.vue?vue&type=script&lang=js&"
export * from "./PaginationSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports